import { useMixpanel } from "@/hooks/useMixpanel";
import { cn } from "@/lib/utils";
import { ChevronRight } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";

interface BreadCrumbsProps {
  className?: string;
  links: { title: string; to: string | number }[];
}

export default function BreadCrumbs({ links, className }: BreadCrumbsProps) {
  const navigate = useNavigate();
  const { trackEvent } = useMixpanel();

  return (
    <div className={cn("mb-6 flex gap-4 font-semibold text-muted-foreground", className)}>
      {links.length > 1 &&
        links.slice(0, -1).map((link) => (
          <React.Fragment key={link.title}>
            <div
              className="cursor-pointer"
              onClick={() => {
                if (typeof link.to === "string") {
                  navigate(link.to);
                } else if (typeof link.to === "number") {
                  navigate(link.to);
                }
                trackEvent("BreadCrumb Link Clicked", { ...link });
              }}
            >
              {link.title}
            </div>
            <ChevronRight />
          </React.Fragment>
        ))}

      {
        <div className="text-secondary underline underline-offset-2">
          {links[links.length - 1].title}
        </div>
      }
    </div>
  );
}
